import { render, staticRenderFns } from "./PatientLogin.vue?vue&type=template&id=fb691ba6&"
import script from "./PatientLogin.vue?vue&type=script&lang=js&"
export * from "./PatientLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports